import elayout from "./layout.module.scss";
import {
  FloatButton,
  MenuProps,
  message,
  Popover,
  Segmented,
  Spin,
  Tag,
  Tooltip,
} from "antd";
import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import LoadingIcon from "../components/Icon/LoadingIcon";
import http from "../http";
import { useUserInfo } from "../context/ThemeContext";
import Image from "next/image";
import { WechatWorkOutlined } from "@ant-design/icons";
import { useRouter } from "next/router";
interface UserCommonData {
  commonData: {
    deepThinking: boolean;
  };
  changeCommonData: (data: any) => void;
}
const CommonDataContext = createContext<UserCommonData | undefined>(undefined);
export default function ELayout(props: { children: JSX.Element }) {
  const router = useRouter();
  const { userInfo, getUserInfo } = useUserInfo();
  const [isLoading, setIsLoading] = useState(false);
  const [commonData, setCommonData] = useState({
    deepThinking: localStorage.getItem("deepThinking") === "true",
  });
  const github_id = useRef("");
  const gitee_code = useRef("");

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (userInfo?.login && token) {
      setTimeout(() => {
        github_id.current = sessionStorage.getItem("github_id") || "";
        github_id.current && linkGithub();
        gitee_code.current = sessionStorage.getItem("gitee_id") || "";
        gitee_code.current && linkGiee();
      }, 100);
    }
  }, [userInfo?.login]);
  useEffect(() => {
    const token = localStorage.getItem("token");
    const deepThinking = localStorage.getItem("deepThinking") === "true";
    changeCommonData({ deepThinking: deepThinking });
    if (!token) {
      return;
    }
    getInfo();
  }, []);
  const changeCommonData = (data: any) => {
    setCommonData({ ...commonData, ...data });
  };
  const linkGiee = () => {
    http
      .post(`/api/v1/thirdparty/gitee/link?gitee_id=${gitee_code.current}`)
      .then((data: any) => {
        if (data.status) {
          getInfo();
          sessionStorage.setItem("gitee_id", "");
        } else {
          message.error(data.message);
        }
      });
  };
  const linkGithub = () => {
    http
      .post(`/api/v1/thirdparty/github/link?github_id=${github_id.current}`)
      .then((data: any) => {
        if (data.status) {
          getInfo();
          sessionStorage.setItem("github_id", "");
        } else {
          message.error(data.message);
        }
      });
  };
  const getInfo = useCallback(() => {
    setIsLoading(true);
    getUserInfo().finally(() => {
      setIsLoading(false);
    });
  }, []);
  return (
    <div className={elayout.elayout}>
      <CommonDataContext.Provider value={{ commonData, changeCommonData }}>
        <div className={elayout.lauout_content}>{props.children}</div>
      </CommonDataContext.Provider>

      <Spin
        spinning={isLoading}
        indicator={<LoadingIcon size={48} />}
        fullscreen
      />
    </div>
  );
}
export const useCommonData = (): UserCommonData => {
  const context = useContext(CommonDataContext);
  if (!context) {
    throw new Error("useThread must be used within a ThreadProvider");
  }
  return context;
};
